import AuthTokenHelper from "helpers/AuthTokenHelper";

function parseJwt(token: string) {
	return JSON.parse(atob(token.split(".")[1]));
}

interface BackofficeUserInfo {
	authorities: string[];
	email: string;
	name: string;
}

export default function useBackofficeUserToken():
	| BackofficeUserInfo
	| undefined
	| null {
	const token: string | null | undefined = AuthTokenHelper.getAuthToken();
	return token ? parseJwt(token) : undefined;
}
